export default function is404Check(pagePath) {
  const is404Regex = /404/;
  return is404Regex.test(pagePath);
}
